export default "__VITE_ASSET__BorvQxDj__"